import { render, staticRenderFns } from "./px-questionary-select.vue?vue&type=template&id=a42f5012&scoped=true&"
import script from "./px-questionary-select.vue?vue&type=script&lang=ts&"
export * from "./px-questionary-select.vue?vue&type=script&lang=ts&"
import style0 from "./px-questionary-select.vue?vue&type=style&index=0&id=a42f5012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42f5012",
  null
  
)

export default component.exports